import React from 'react';
import TableBilling from '../../../component/TableBilling/TableBilling';
import { Badge, Button } from 'react-bootstrap';
import { MdHistory } from "react-icons/md";
import moment from 'moment';
import { TAB_LIST } from '../../../BillingUsage';
import { I18n } from 'react-redux-i18n';
import { TRANSACTION_TYPE_BILLING } from '../../billingTransactionHistory/BillingTransactionHistory';
import {
  formatCurrencyHasSymbol,
  formatLongTypeToNumberCurrency,
} from '../../../../../utils/commonFunctions';

export const handleValueAmount = (data, currencyISO) => {
	let className = '';
	let value = '';
	if ([TRANSACTION_TYPE_BILLING.addOn, 
		TRANSACTION_TYPE_BILLING.booking,
		TRANSACTION_TYPE_BILLING.bookingDeduct,
		TRANSACTION_TYPE_BILLING.cancellationPenalty,
		TRANSACTION_TYPE_BILLING.noShowPenalty,
		TRANSACTION_TYPE_BILLING.withdraw,
	].includes(data.transactionType)) {
		className = 'text-danger';
		value = '-';
	} else {
		className = 'text-success';
	}

	if (data.transactionType === TRANSACTION_TYPE_BILLING.systemTopUp) {
		if (data.amount >= 0) {
			className = 'text-success';
		} else {
			className = 'text-danger';
		}
	}
	
	return <span className={className}>{value}{formatCurrencyHasSymbol(formatLongTypeToNumberCurrency(data.amount, currencyISO), currencyISO)}</span>;
}

export default function TransactionHistory({ data = [], onTabSelect, billingUsage }) {
	const columns = [
		{ title: I18n.t('billingUsage.date'), dataIndex: 'date', render: (v) => moment(v).format('MMM D, YYYY') },
		{
			title: I18n.t('report.query.transactionType'), dataIndex: 'transactionType', render: (v) => (
				v ? I18n.t(`billingUsage.${v}`) : ''
			)
		},
		{ title: I18n.t('report.query.referralDetail.Reference'), dataIndex: 'reference'},
		{ title: I18n.t('report.query.referralDetail.Status'), dataIndex: 'status', render: (v) => (
			v ? I18n.t(`billingUsage.${v}`) : ''
		) },
		{ title: I18n.t('billingUsage.amount'), dataIndex: 'amount', render: (v,r) => {
			return handleValueAmount(r, billingUsage?.currencyISO);
		} },
	];

	const footerText = I18n.t('billingUsage.onlyPreviewShown');

	return (
		<div className="p-4 billing-table-container mt-4">
			<div className="table-header-billing d-flex justify-content-between align-items-center">
				<h4>{I18n.t('billingUsage.recentTransactions')}</h4>
				<div className="d-flex align-items-center rightContent">
					<span className="last-7-days">{I18n.t('billingUsage.last7Days')}</span>
					<Button variant="link" size="sm" className="billing-btn" onClick={() => onTabSelect(TAB_LIST.transactionHistory)}>
						<MdHistory size={16} className='mr-1' />
						{I18n.t('billingUsage.viewHistory')}
					</Button>
				</div>
			</div>
			<TableBilling data={data} columns={columns} footerText={footerText} />
		</div>
	);
}